export class PricesWrapper {
  priceUkv = 0;
  priceBk = 0;
}
